import { titleCase } from 'title-case';

/* eslint-disable complexity */
export function transformVariation(variation, category) {
  const isPreroll =
    category?.toLowerCase().replace('_', '').replace('-', '') === 'prerolls';

  switch (variation?.toLowerCase()) {
    case '1/8oz': {
      return '3.5g';
    }
    case '1/4oz': {
      return isPreroll ? 'Multi-Pack (7g)' : '7g';
    }
    case '1/2oz': {
      return isPreroll ? 'Multi-Pack (14g)' : '14g';
    }
    case '28g': {
      return isPreroll ? 'Multi-Pack (1oz)' : '1oz';
    }
    case '1oz': {
      return isPreroll ? 'Multi-Pack (1oz)' : '1oz';
    }
    case '.7g': {
      return isPreroll ? 'Single (.7g)' : '.7g';
    }
    case '1g': {
      return isPreroll ? 'Single (1g)' : '1g';
    }
    case '1.25g': {
      return isPreroll ? 'Single (1.25g)' : '1.25g';
    }
    case '1.3g': {
      return isPreroll ? 'Single (1.3g)' : '1.3g';
    }
    case '1500mg': {
      return isPreroll ? 'Single (1.5g)' : '1500mg';
    }
    case '1.5g': {
      return isPreroll ? 'Multi-Pack (1.5g)' : '1.5g';
    }
    case '2.1g': {
      return isPreroll ? 'Multi-Pack (2.1g)' : '2.1g';
    }
    case '2.5g': {
      return isPreroll ? 'Multi-Pack (2.5g)' : '2.5g';
    }
    case '3g': {
      return isPreroll ? 'Multi-Pack (3g)' : '3g';
    }
    case '4g': {
      return isPreroll ? 'Multi-Pack (4g)' : '4g';
    }
    case '6g': {
      return isPreroll ? 'Multi-Pack (6g)' : '6g';
    }
    case '50g': {
      return isPreroll ? 'Multi-Pack (50g)' : '50g';
    }
    case 'x-small': {
      return 'XS';
    }
    case 'small': {
      return 'S';
    }
    case 'medium': {
      return 'M';
    }
    case 'large': {
      return 'L';
    }
    case 'x-large': {
      return 'XL';
    }
    case '2x-large': {
      return '2XL';
    }
    case '3x-large': {
      return '3XL';
    }
    case '4x-large': {
      return '4XL';
    }
    case '5x-large': {
      return '5XL';
    }
    case '6x-large': {
      return '6XL';
    }
    default: {
      return variation;
    }
  }
}
/* eslint-enable complexity */

export function transformVariationLabel(variation, category) {
  switch (variation) {
    case 'XS':
    case 'S':
    case 'M':
    case 'L':
    case 'XL':
    case 'XXL':
    case 'XXXL':
    case '2XL':
    case '3XL':
    case '4XL':
    case '5XL':
    case '6XL': {
      return 'SIZE';
    }
    default:
  }

  switch (category?.replace('_', '').replace('-', '').toLowerCase()) {
    case 'edibles': {
      return 'QUANTITY';
    }
    case 'prerolls': {
      return 'QUANTITY (TOTAL WEIGHT)';
    }
    case 'accessories':
    case 'apparel': {
      return;
    }
    case 'cbd': {
      return 'DOSAGE';
    }
    case 'flower': {
      return 'WEIGHT - THC %';
    }
    default: {
      return 'WEIGHT';
    }
  }
}

function toTitleCase(productName) {
  let name = titleCase(productName.toLowerCase());
  name = name
    .split(' ')
    .map((word) => {
      switch (word) {
        case 'Gmo': {
          return 'GMO';
        }
        case 'Thc': {
          return 'THC';
        }
        case 'cbd:Thc': {
          return 'CBD:THC';
        }
        case 'Cbd': {
          return 'CBD';
        }
        case 'De': {
          return 'de';
        }
        case 'La': {
          return 'la';
        }
        case 'Og': {
          return 'OG';
        }
        case '(Xs)': {
          return '(XS)';
        }
        case '(Xl)': {
          return '(XL)';
        }
        case '(Xxl)': {
          return '(XXL)';
        }
        case '(Xxxl)': {
          return '(XXXL)';
        }
        case '(4xl)': {
          return '(4XL)';
        }
        case '(5xl)': {
          return '(5XL)';
        }
        case '(6xl)': {
          return '(6XL)';
        }
        case 'Gg4': {
          return 'GG4';
        }
        case 'Usb': {
          return 'USB';
        }
        case "Gmo'z": {
          return "GMO'z";
        }
        default: {
          return word;
        }
      }
    })
    .join(' ');
  return name;
}

function categoryAppend(productName, category) {
  let result = productName;

  switch (category) {
    case 'PREROLL': {
      if (!productName.endsWith('Preroll')) {
        result = `${productName} Preroll`;
      }
      break;
    }
    case 'FLOWER': {
      if (!productName.endsWith('Flower')) {
        result = `${productName} Flower`;
      }
      break;
    }
    default: {
      break;
    }
  }

  return result;
}

function removeVariantSize(productName, category) {
  let result = productName;

  if (category === 'PREROLL' || category === 'FLOWER') {
    result = productName
      .replace(/\d+(\.\d)*(G|MG)/, '')
      .replace(/\d{0,2}[ -]PACK/, '')
      .trim();
  }

  return result;
}

export function transformProductName(productName, category) {
  return categoryAppend(
    toTitleCase(removeVariantSize(productName, category)),
    category
  );
}

export function transformPriceFilterLabel(priceLabel) {
  switch (priceLabel) {
    case 'UNDER_TWENTY_FIVE': {
      return 'Under $25';
    }
    case 'TWENTY_FIVE_TO_UNDER_FIFTY': {
      return '$25 to $49.99';
    }
    case 'FIFTY_TO_UNDER_ONE_HUNDRED': {
      return '$50 to $99.99';
    }
    case 'ONE_HUNDRED_AND_ABOVE': {
      return '$100 & Above';
    }
    default: {
      return priceLabel;
    }
  }
}

export function transformFacetName(facetName) {
  switch (facetName) {
    case 'Quantity_Total_Weight': {
      return 'Quantity (Total Weight)';
    }
    case 'Offers': {
      return 'Offering';
    }
    case 'Collections': {
      return 'Collection';
    }
    default: {
      return facetName.replace(/_/g, ' ');
    }
  }
}

export function transformSizeToSortRank(size) {
  const sizeKey = size?.toLowerCase();

  switch (sizeKey) {
    case 'x-small': {
      return 1;
    }
    case 'small': {
      return 2;
    }
    case 'medium': {
      return 3;
    }
    case 'large': {
      return 4;
    }
    case 'x-large': {
      return 5;
    }
    case '2x-large': {
      return 6;
    }
    case '3x-large': {
      return 7;
    }
    case '4x-large': {
      return 8;
    }
    case '5x-large': {
      return 9;
    }
    case '6x-large': {
      return 10;
    }
    default:
  }

  const strippedSizeKey = sizeKey
    ?.replace('oz', '')
    .replace('mg', '')
    .replace('g', '')
    .replace('$', '');

  const sortRank = Number(strippedSizeKey);

  return Number.isNaN(sortRank) ? 1000 : sortRank;
}

export function transformLabResultUnit(unit) {
  switch (unit?.toLowerCase()) {
    case 'percentage': {
      return '%';
    }
    case 'milligrams': {
      return 'mg';
    }
    default: {
      return unit;
    }
  }
}
